import { Waitlist } from "@/components/Waitlist";
import { Reveal } from "@/components/Reveal";

export default function JoinPage() {
  return (
    <main data-testid="join-page" className="bg-[#EFE8DC] text-[#2C241E] pt-24 min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-10 pb-6 text-center">
        <Reveal>
          <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50">
            First access · Founding member pricing · No spam
          </p>
        </Reveal>
      </div>
      <Waitlist selection={null} />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex items-center justify-center gap-8">
        <a
          href="#"
          data-testid="social-instagram"
          className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 transition-colors duration-200 hover:text-[#2C241E]"
        >
          Instagram
        </a>
        <span className="h-1 w-1 rounded-full bg-[#A07856]" />
        <a
          href="#"
          data-testid="social-tiktok"
          className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 transition-colors duration-200 hover:text-[#2C241E]"
        >
          TikTok
        </a>
      </div>
    </main>
  );
}
